import { type FC, memo } from 'react';
import { useParams } from 'wouter';
import { JsonLd } from '@/base/JsonLd';
import { useCoin } from '@/shared/api';
import { ClientOnly } from '@/shared/ClientOnly';

export const CoinJsonLd: FC = memo(() => {
  const { slug } = useParams<{ slug: string }>();
  const { data: coin } = useCoin(slug?.toUpperCase());
  const symbol = coin?.symbol ?? slug?.toUpperCase() ?? '';

  const rates = coin
    ? [
        { currency: 'USDT', value: Number(coin.price_usdt) },
        { currency: 'IQD', value: Number(coin.price_iqd) },
      ].filter((rate) => rate.value > 0)
    : [];

  if (rates.length === 0) return null;

  // Live price is excluded from the prerendered snapshot (would be stale);
  // ClientOnly renders it only after hydration.
  return (
    <ClientOnly>
      {rates.map((rate) => (
        <JsonLd
          key={rate.currency}
          data={{
            '@context': 'https://schema.org',
            '@type': 'ExchangeRateSpecification',
            currency: symbol,
            currentExchangeRate: {
              '@type': 'MonetaryAmount',
              currency: rate.currency,
              value: rate.value,
            },
          }}
        />
      ))}
    </ClientOnly>
  );
});
